





























import Vue from 'vue';
import { mapGetters } from 'vuex';
import InstitutionCard from '@/components/cards/InstitutionCard.vue';
import pxButton from '@/dex-shared/components/px-button.vue';
import Pagination from '@/components/Pagination.vue';
import Header from '@/components/Header.vue';
import Loading from '@/dex-shared/components/Loading.vue';
import InstitutionModel from '@/dex-shared/models/InstitutionModel';

export default Vue.extend({
  components: {
    InstitutionCard,
    pxButton,
    Pagination,
    Header,
    Loading,
  },

  data() {
    return {
      currentPage: 0,
      loaded: false,
    };
  },

  computed: {
    ...mapGetters({
      allInstitutions: 'allInstitutions',
    }),
    institutions() {
      return this.allInstitutions
        .concat()
        .sort((a: InstitutionModel, b: InstitutionModel) =>
          a.title.localeCompare(b.title),
        );
    },
  },

  created() {
    const page = parseInt(this.$route.params.page);
    if (page > 0) {
      this.currentPage = page - 1;
    } else {
      this.$router.replace(`/instituicoes`);
    }
    this.pullInfo();
  },

  methods: {
    pullInfo: async function() {
      this.loaded = false;
      try {
        await this.$store.dispatch('PULL_INSTITUTIONS', {
          currentPage: this.currentPage,
        });
      } catch (e) {
        alert(
          `Algo deu errado. Envie essas informações para os desenvolvedores: ${e}`,
        );
      }
      this.loaded = true;
    },
    changePage: async function(event: number) {
      this.currentPage = event;
      await this.pullInfo();
      this.$router.push(`/instituicoes/${this.currentPage + 1}`);
    },
  },
});
